export const Clock = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        d="M12.2298 11.8861V12.2194H12.5631H17.4756C17.7507 12.2194 17.9673 12.4531 17.9673 12.7486C17.9673 13.0145 17.7415 13.2403 17.4756 13.2403H11.7381C11.4722 13.2403 11.2464 13.0145 11.2464 12.7486V6.33611C11.2464 6.0702 11.4722 5.84444 11.7381 5.84444C12.004 5.84444 12.2298 6.0702 12.2298 6.33611V11.8861Z"
        fill="#8899A8"
        stroke="#8899A8"
        strokeWidth="0.666667"
      />
      <path
        d="M12.0003 0.524109C5.73779 0.524109 0.675293 5.66161 0.675293 11.9991C0.675293 18.3366 5.73779 23.4741 12.0003 23.4741C18.2628 23.4741 23.3253 18.3366 23.3253 11.9991C23.3253 5.66161 18.2628 0.524109 12.0003 0.524109ZM12.0003 21.7866C6.67529 21.7866 2.32529 17.3991 2.32529 11.9991C2.32529 6.59911 6.67529 2.21161 12.0003 2.21161C17.3253 2.21161 21.6753 6.59911 21.6753 11.9991C21.6753 17.3991 17.3253 21.7866 12.0003 21.7866Z"
        fill="#8899A8"
      />
    </svg>
  );
};
